export const SIZED_SUB_CATEGORIES = new Set([
  "footwear",
  "apparel",
  "uniform-n-belts",
]);

export const FOOTWEAR_EU_SIZES = Array.from({ length: 14 }, (_, i) => String(35 + i));

export const APPAREL_SIZES = ["XS", "S", "M", "L", "XL", "XXL", "3XL"];

/** Apparel colorways: one of these per unit, chosen in the cart. */
export const APPAREL_FIT_SIZES = ["Small", "Medium", "Large", "XLarge"];

export function normalizeSubCategory(value) {
  return String(value || "").trim().toLowerCase();
}

export function itemNeedsSize(item) {
  return SIZED_SUB_CATEGORIES.has(normalizeSubCategory(item?.sub_category));
}

export function isFootwearItem(item) {
  return normalizeSubCategory(item?.sub_category) === "footwear";
}

export function isApparelItem(item) {
  return normalizeSubCategory(item?.sub_category) === "apparel";
}

export function sizeOptionsForItem(item) {
  if (isFootwearItem(item)) return FOOTWEAR_EU_SIZES;
  if (isApparelItem(item)) return APPAREL_FIT_SIZES;
  return APPAREL_SIZES;
}

export function sizeFieldLabel(item) {
  if (isFootwearItem(item)) return "EU shoe size";
  return "Size";
}

export function ensureItemSizeSlots(item) {
  if (!itemNeedsSize(item)) {
    item.sizes = [];
    return;
  }
  if (!Array.isArray(item.sizes)) {
    item.sizes = [];
  }
  const qty = Number(item.quantity) || 0;
  while (item.sizes.length < qty) {
    item.sizes.push("");
  }
  while (item.sizes.length > qty) {
    item.sizes.pop();
  }
}

export function itemSizesComplete(item) {
  if (!itemNeedsSize(item)) return true;
  ensureItemSizeSlots(item);
  return item.sizes.every((value) => String(value || "").trim());
}

export function formatItemSizesSummary(item) {
  if (!itemNeedsSize(item)) return "";
  const sizes = Array.isArray(item.sizes) && item.sizes.length
    ? item.sizes
    : item.size
      ? [item.size]
      : [];
  if (!sizes.length) return "";
  const label = sizeFieldLabel(item);
  if (sizes.length === 1) return `${label}: ${sizes[0]}`;
  return sizes.map((value, index) => `Unit ${index + 1}: ${value}`).join(", ");
}
